// The brand color in use as a hex value: the company's own (App.vue sets --primary-color from it) or style.scss's
// default. For color pickers and colors that get saved; styles use var(--primary-color) directly.
export function primaryColor(): string {
    return getComputedStyle(document.documentElement).getPropertyValue('--primary-color').trim();
}
